<template>
  <div :class="$style['wrapper']">
    <span
      :class="$style['mobile-menu-icon']"
      @click="openMobile"
    >
      <ds-menu-icon />
    </span>
    <div :class="$style['inner']">
      <span :class="$style['logo-wrapper']">
        <a href="https://dataspace.pl">
          <ds-logo-icon :class="$style['logo']" />
        </a>
        <div :class="$style['separator']" />
        <a href="/">
          <div :class="$style['app-title']">
            <ds-toolbox-icon />
          </div>
        </a>
      </span>
      <div :class="$style['services-wrapper']">
        <span v-if="services">
          <span :class="$style['services-on']" />
          <span :class="$style['services-text']">Wszystkie usługi działają prawidłowo</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { openMobileMenu, closeMobileMenu } from "@/app/ui/store/mutations";
import ToolboxService from "@/app/dashboard/services/toolbox.service";
import DsToolboxIcon from "./ds-toolbox-icon";

export default {
  name: "TopHeader",
  components: {
    DsToolboxIcon
  },
  data() {
    return {
      services: null,
      isFetchingServices: false
    };
  },
  computed: {
    ...mapState({
      isMobileMenuOpen: state => state.ui.isMobileMenuOpen
    })
  },
  async mounted() {
    let resultData = null;
    resultData = await ToolboxService.checkServices();
    this.services = resultData.data;
  },
  methods: {
    openMobile: function() {
      if (this.isMobileMenuOpen) {
        this.$store.commit(closeMobileMenu());
      } else {
        this.$store.commit(openMobileMenu());
      }
    }
  }
};
</script>

<style lang="scss" module>
@import "~@app/scss/_variables.scss";
@import "~@theme/scss/_mixins.scss";
@import "~@theme/scss/_variables.scss";

.wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0px 45px 0px 20px;
  height: 100%;
  @include mobile() {
    margin: 0px;
    width: 100vw;
  }
}
.inner {
  display: flex;
  align-items: center;
  width: 100%;
  @include mobile() {
    display: flex;
    align-items: center;
    margin-left: auto;
    justify-content: flex-start;
  }
}
.logo {
  @include mobile() {
    width: initial;
  }
}
.menu-wrapper {
  margin-left: auto;
  @include mobile() {
    margin-left: initial;
  }
}
.submenu {
  display: flex;
  margin-bottom: 15px;
  > li {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    line-height: 24px;
    border-radius: 5px;
    color: #000;
    margin-top: 5px;
    &:not(:first-child) {
      margin-left: 60px;
    }
    img {
      margin-right: 10px;
    }
  }
  @include mobile() {
    display: none;
  }
}
.menu-link {
  margin-top: 13px !important;
  a {
    display: flex;
    align-items: center;
    color: #000;
    > span {
      margin-right: 10px;
      display: flex;
    }
  }
}
.logo-wrapper {
  display: flex;
  align-items: center;
  svg {
    width: 200px;
    height: 100%;
    margin-top: 2px;
  }
  > span {
    display: flex;
    align-items: center;
    @include mobile() {
      svg {
        width: 40vw !important;
        max-width: 140px;
        margin-right: 15px;
        // margin-right: 30px;
      }
    }
  }
}
.mobile-menu-icon {
  display: none;
  z-index: 2;
  @include mobile() {
    display: flex;
    svg {
      height: 3rem;
      width: 45px;
    }
  }
}
.mobile-submenu {
  display: none;
  @include mobile() {
    display: flex;
    align-items: center;
    margin: -10px;
    > * {
      margin: 10px;
    }
  }
}
.app-title {
  color: $light-gray-color;
  font-size: $font-large-size;
  font-weight: 600;
  position: relative;
  svg {
    width: initial !important;
    height: 40px !important;
  }
  @include mobile() {
    font-size: $font-big-size;
  }
}
.separator {
  width: 2px;
  background-color: $light-gray-color;
  height: 34px;
  margin-left: 26px;
  margin-right: 29px;
  opacity: 0.3;
  letter-spacing: 1px;
  @include mobile() {
    display: none;
  }
}
.app-alpha-title {
  font-size: 12px;
  position: absolute;
  top: 5px;
  right: -35px;
  font-weight: 600;
}
.services-on {
  display: flex;
  align-items: center;
  margin-right: 5px;
  @include mobile() {
    margin-right: 15px;
  }
  &:before {
    content: "";
    display: inline-block;
    border-radius: 50px;
    width: 1em;
    height: 1em;
    background-color: #00d589;
  }
}
.services-wrapper {
  margin-left: auto;
  > * {
    display: flex;
    align-items: center;
  }
  font-size: 12px;
  font-weight: 600;
  color: $black-blue-color;
}
.services-text {
  @include mobile() {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/top-header.vue